import {
defineCustomElement,
MediaChapterTitleElement
} from "vidstack/elements";

defineCustomElement(MediaChapterTitleElement);